import React, { useState } from 'react'
import { useDebounce } from 'react-use'

interface ChipTextInputProps {
  id: string
  value: string
  onChange: (value: string) => void
  placeholder: string
  disabled?: boolean
}

export const ChipTextInput = React.forwardRef<HTMLInputElement, ChipTextInputProps>(
  ({ id, value, onChange, placeholder, disabled = false }, ref) => {
    const [currentValue, setCurrentValue] = useState(value)

    useDebounce(
      () => {
        onChange(currentValue)
      },
      800,
      [currentValue]
    )

    return (
      <input
        id={id}
        type='text'
        ref={ref}
        autoFocus={!disabled}
        disabled={disabled}
        className='bg-transparent appearance-none outline-hidden w-full'
        placeholder={placeholder}
        value={currentValue}
        onChange={(e) => {
          if (!disabled) {
            setCurrentValue(e.currentTarget.value)
          }
        }}
      />
    )
  }
)

ChipTextInput.displayName = 'ChipTextInput'
